import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { ResourceConsumptionBaseEffect } from './resource-consumption-base.effect';
import { ResourceConsumptionEntity } from './resource-consumption-base.entity';
import { resourceConsumptionBaseReducer } from './resource-consumption-base.reducer';
import { FEATURE_NAME } from './resource-consumption-base.constant';

@NgModule({
  imports: [
    StoreModule.forFeature(FEATURE_NAME, resourceConsumptionBaseReducer),
    EffectsModule.forFeature([ResourceConsumptionBaseEffect])
  ],
  providers: [
    ResourceConsumptionEntity
  ]
})
export class ResourceConsumptionBaseModule {

}
